export enum SocketActionEnum {
  EMAIL = 'email',
  FACEBOOK = 'facebook',
  ZALO = 'zalo',
  CHAT = 'CHAT',
}



// WEBPACK FOOTER //
// ./src/app/common/enums/socket-notify-type.enum.ts